import {type FeatureName} from '@hproduce/suite-core'

export const PLANT_STATUS_SUB_PATH: FeatureName = 'PerformanceReports'
